import React, { useEffect, useState } from 'react';
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink,Image } from '@react-pdf/renderer';
import { Button, HStack, Heading, Input, VStack } from '@chakra-ui/react';
import sls from '../images/sls.png'
import axios from 'axios';
import { backendurl } from '../path';
// Create styles
const styles = StyleSheet.create({
    container: {
      padding: 20,
    },
    header: {
      textAlign: 'center',
      fontSize: 24,
      marginBottom: 20,
    },
    logo: {
      width: 120,
      height: 120,
      alignSelf: 'center',
      marginBottom: 20,
    },
    address: {
      marginBottom: 20,
      borderBottom:'1px solid gray',
      paddingBottom:4,
    },
    fieldsContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 20,
    },
    total:{
        marginTop: 30,
        borderTop:'1px solid gray',
    },
   
    inner:{
        flexDirection: 'row',
    },
    topcont:{
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    fieldLabel: {
      fontWeight: 'bold',
      marginRight:20,
    },
    fielddata:{
        fontWeight:'hairline',
        fontSize:16,
    }
   
  });
  
// Create PDF component
const MyDocument = ({data}) => (
    <Document>
    <Page size="A5">
      <View style={styles.container}>
      <View style={styles.topcont}>
        <Text style={styles.header}>FEE RECEIPT</Text>
        <Image src={sls} style={styles.logo} />
        </View>
        <View style={styles.address}>
          <Text>S.L.S Memorial Public School</Text>
          <Text>Budina Kalan, Muzaffarnagar</Text>
          <Text>Uttar Pradesh, India</Text>
        </View>

       
        <View style={styles.fieldsContainer}>
            <View style={styles.inner}>
          <Text style={styles.fieldLabel}>Date:</Text>
          <Text style={styles.fielddata}>{data.date}</Text>
            </View>
        </View>

        <View style={styles.fieldsContainer}>
        <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Student Name:</Text>
          <Text style={styles.fielddata}>{data.studentName}</Text>
            </View>
        </View>

        <View style={styles.fieldsContainer}>
        <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Father Name:</Text>
          <Text style={styles.fielddata}>{data.fatherName}</Text>
            </View>
        </View>
        
        <View style={styles.fieldsContainer}>
        <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Phone:</Text>
          <Text style={styles.fielddata}>{data.mobileno}</Text>
            </View>
        </View>
        

        <View style={styles.fieldsContainer}>
            <View style={styles.inner}>
          <Text style={styles.fieldLabel}>Class:</Text>
          <Text style={styles.fielddata}>{data.class}</Text>
            </View>
            <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Section:</Text>
          <Text style={styles.fielddata}>{data.section}</Text>
            </View>
        </View>
       
        <View style={styles.fieldsContainer}>
            <View style={styles.inner}>
          <Text style={styles.fieldLabel}>Month:</Text>
          <Text style={styles.fielddata}>{data.month}</Text>
            </View>
            <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Tution Fee:</Text>
          <Text style={styles.fielddata}>Rs {data.tuitionFee}</Text>
            </View>
        </View>

        <View style={styles.fieldsContainer}>
            <View style={styles.inner}>
          <Text style={styles.fieldLabel}>Transport Fee:</Text>
          <Text style={styles.fielddata}>Rs{data.transportFee}</Text>
            </View>
            <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Other Charges:</Text>
          <Text style={styles.fielddata}>Rs{data.otherCharges}</Text>
            </View>
        </View>
    
        <View style={styles.total}>
          <Text style={styles.fieldLabel}>Total:</Text>
          <Text>Rs {data.total}</Text>
        </View>
    
      </View>
    </Page>
  </Document>
);


const Payslip = ({id})=>{

    const [name,setname] = useState(null);
    const [fname,setfname] = useState(null);
    const [phone,setphone] = useState(null);
    const [date,setdate] = useState(null);
    const [Class,setclass] = useState(null);
    const [sec,setsec] = useState(null);
    const [mon,setmon] = useState(null);
    const [tf,settf] = useState(null);
    const [transfee,settransfee] = useState(null);
    const [otc,setotc] = useState(null);
    const [tot,settot] = useState(null);

    useEffect(() => {
    settot(Number(tf)+Number(transfee)+Number(otc));
    }, [tf,transfee,otc])

    const receiptData = {
        date: date,
        studentName: name,
        class: Class,
        section: sec,
        month: mon,
        tuitionFee: tf,
        transportFee: transfee,
        otherCharges: otc,
        fatherName: fname,
        mobileno: phone,
        total: tot,
      };

      const handlepay =async()=>{
        const response = await axios.post(`${backendurl}/pay-fee`,{"_id":id,"amount":tot,"month":mon});
        if(response.data.paid)
        {
            window.location.reload();
        }
    }

    return (
      
      <>
            <VStack >
              <Heading fontSize={'2xl'}>Pay Fee</Heading>
      <HStack w={'full'} >
         <Input type='date' value={date} onChange={(e)=>setdate(e.target.value)}/>     
       <Input type='text' placeholder='student name' value={name} onChange={(e)=>setname(e.target.value)}/>     
       <Input type='text' placeholder='father name' value={fname} onChange={(e)=>setfname(e.target.value)}/>     
        </HStack>
        <HStack>
       <Input type='number' placeholder='phone number' value={phone} onChange={(e)=>setphone(e.target.value)}/>     
       <Input type='text' placeholder='class' value={Class} onChange={(e)=>setclass(e.target.value)}/>     
       <Input type='text' placeholder='section' value={sec} onChange={(e)=>setsec(e.target.value)} />     
        </HStack>
       <Input type='month' placeholder='month' value={mon} onChange={(e)=>setmon(e.target.value)}/>     
       <Input type='number' placeholder='tution fee' value={tf} onChange={(e)=>settf(e.target.value)}/>     
       <Input type='number' placeholder='transport fee' value={transfee} onChange={(e)=>settransfee(e.target.value)}/>     
       <Input type='number' placeholder='other charges' value={otc} onChange={(e)=>setotc(e.target.value)}/>
       <Input type='number' placeholder='total' readOnly value={tot}/>     
            </VStack>
       

        <Button colorScheme='orange' variant={'solid'} mb={8} onClick={handlepay}>
        <PDFDownloadLink document={<MyDocument data={receiptData} />} fileName="FeeSlip.pdf">
          {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Download PDF')}
        </PDFDownloadLink>
        </Button>
      </>
    )
}

export default Payslip;
